import { useShallow } from 'zustand/react/shallow';
import { IProductDetailsGridParams } from '../../../../services/modules/productDetails/productDetails.types';
import useProductDetailsStore from '../../../../stores/ProductDetails/productDetails.store';
import useProductDetailsPreferences from './useProductDetailsPreferences';

export interface OpenProductDetailsParams {
  productId?: string;
  productColorId?: string;
  kitId?: string;
}

const useOpenProductDetails = () => {
  const { getProductDetailsPreferences } = useProductDetailsPreferences();
  const { productGridParams, setProductDetailsModalState, handleOpenProductDetailsModal } =
    useProductDetailsStore(
      useShallow((state) => ({
        productGridParams: state.productGridParams,
        setProductDetailsModalState: state.setProductDetailsModalState,
        handleOpenProductDetailsModal: state.handleOpenProductDetailsModal,
      })),
    );

  const openProductDetails = ({ productId, productColorId, kitId }: OpenProductDetailsParams) => {
    const preferences = getProductDetailsPreferences(productColorId);

    if (kitId) {
      setProductDetailsModalState({ isOpen: true, kitId });
      handleOpenProductDetailsModal(
        {
          ...productGridParams,
          orderIds: preferences.orderIds,
          isFinishedOrder: false,
          availability: undefined,
        },
        preferences.shouldApplyRelatedProducts,
      );
      return;
    }

    setProductDetailsModalState({ isOpen: true, productId, productColorId });

    const gridParams: IProductDetailsGridParams = {
      ...productGridParams,
      productColorId: preferences.productColorId,
      availability: preferences.availability,
      isFinishedOrder: false,
      orderIds: preferences.orderIds,
    };

    handleOpenProductDetailsModal(gridParams, preferences.shouldApplyRelatedProducts);
  };

  return { openProductDetails };
};

export default useOpenProductDetails;
